import { AnswerbookItem } from '@/types/question';
import { ref } from 'vue';

export type ShareConfig = {
  show: boolean;
  questionData?: AnswerbookItem;
  slipBackgroundUrl?: string;
};

const shareConfig = ref<ShareConfig>({ show: false, questionData: undefined });

export const useShare = () => {
  const showShare = (data: AnswerbookItem, slipBackgroundUrl?: string) => {
    shareConfig.value.questionData = data;
    shareConfig.value.slipBackgroundUrl = slipBackgroundUrl;
    shareConfig.value.show = true;
  };

  const hideShare = () => {
    shareConfig.value.show = false;
    shareConfig.value.questionData = undefined;
    shareConfig.value.slipBackgroundUrl = undefined;
  };

  return { shareConfig, showShare, hideShare };
};
